const privacy ={
    title: "Privacy Policy",
    summary: `This privacy policy will explain how Dirigierakademie uses the personal data we collect from you when you use our website.`,
    Topics: [
        `What data do we collect?`,
        `How do we collect your data?`,
        `How will we use your data?`,
        `How do we store your data?`,
        `Marketing`,
        `What are your data protection rights?`,
        `What are cookies?`,
        `How do we use cookies?`,
        `What types of cookies do we use?`,
        `How to manage your cookies`,
        `Privacy policies of other websites`,
        `Changes to our privacy policy`,
        `How to contact us`,
        `How to contact the appropriate authorities`,
    ],
    questions:[
        {
            question: `What data do we collect?`,
            answer: [`Our company collects the follow data:`],
            list:[`Personal identification information (name, email address, phone number, etc.)`,`Information relevant for applications (educational background, instruments played, age, etc.)`
            ],
        },
        {
            question: `How do we collect your data?`,
            answer: [`You directly provide Dirigierakademie with most of the data we collect. We collect data and process data when you:`],
            list:[`Contact us by email or using our online contact form.`,`Apply to one of our courses via email and/or using the application form on our website.`,`Use or view our website via your browser’s cookies.`
            ],
        },
        {
            question: `How will we use your data?`,
            answer: [`Our Company collects your data so that we can:`],
            list:[`Process your application`,`Email you in response to queries`, `Email you with regarding future courses which may interest you`
            ],
        },
        {
            question: `How do we store your data?`,
            answer: [`Our Company stores your data in a secure GoogleDrive account which can be accessed by two password protected private computers, owned by Dirigierakademie's directors.`, `Our company will keep your data for five years. Once this time period has expired, we will permanently delete your data.`],
            list:[],
        },
        {
            question: `Marketing`,
            answer:[ `Dirigierakademie would like to send you information about products and services of ours that we think you might like.`, 
            `If you have agreed to receive marketing, you may always opt out at a later date`,
            `You have the right at any time to stop Dirigierakademie from contacting you for marketing purposes or giving your data to other members of the Our Company Group.`
        ],
            list:[],
        },
        {
            question: `What are your data protection rights?`,
            answer: [
                `Our Company would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:`,
                `The right to access - You have the right to request Dirigierakademie for copies of your personal data. We may charge you a small fee for this service.`,
                `The right to rectification - You have the right to request that Dirigierakademie correct any information you believe is inaccurate. You also have the right to request Dirigierakademie to complete the information you believe is incomplete.`,
                `The right to erasure - You have the right to request that Dirigierakademie erase your personal data, under certain conditions.`,
                `The right to restrict processing - You have the right to request that Dirigierakademie restrict the processing of your personal data, under certain conditions.`,
                `The right to object to processing - You have the right to object to Dirigierakademie's processing of your personal data, under certain conditions.`,
                `The right to data portability - You have the right to request that Dirigierakademie transfer the data that we have collected to another organization, or directly to you, under certain conditions.`,
                `If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us at our email:`,
                `contact@dirigierakademie.com`
            ],
            list:[],
        },
        {
            question: `Cookies`,
            answer: [`Cookies are text files placed on your computer to collect standard Internet log information and visitor behavior information. When you visit our websites, we may collect information from you automatically through cookies or similar technology.`,
            `For further information, visit allaboutcookies.org.`
        ],
            list:[],
        },
        {
            question: `How do we use cookies?`,
            answer: [`Our Company uses cookies in a range of ways to improve your experience on our website, including:`],
            list:[`Understanding how you use our website`],
        },
        {
            question: `What types of cookies do we use?`,
            answer: [`There are a number of different types of cookies, however, our website uses:`],
            list:[`Functionality - Our Company uses these cookies so that we recognize you on our website and remember your previously selected preferences. These could include what language you prefer and location you are in. A mix of first-party and third-party cookies are used.`],
        },
        {
            question: `How to manage cookies`,
            answer: [`You can set your browser not to accept cookies, and the above website tells you how to remove cookies from your browser. However, in a few cases, some of our website features may not function as a result.`],
            list:[],
        },
        {
            question: `Privacy policies of other websites`,
            answer: [`The Our Company website contains links to other websites. Our privacy policy applies only to our website, so if you click on a link to another website, you should read their privacy policy.`],
            list:[],
        },
        {
            question: `Changes to our privacy policy`,
            answer: [`Our Company keeps its privacy policy under regular review and places any updates on this web page. This privacy policy was last updated on 30 October 2022.`],
            list:[],
        },
        {
            question: `How to contact us`,
            answer: [`If you have any questions about Our Company’s privacy policy, the data we hold on you, or you would like to exercise one of your data protection rights, please do not hesitate to contact us.`,
        `Email us at: contact@dirigierakademie.com`],
            list:[],
        },
    ]
}


export {privacy}